import React from "react";

import styled from "styled-components";

const FooterContainer = styled.footer`
  background-color: #000; /* Match navbar/hero background */
  color: #fff;
  padding: 2rem 1rem;
  text-align: center;
  width: 100%;
  position: absolute;
  bottom: 0;
`;

const SocialLinks = styled.div`
  margin-top: 1rem;
  display: flex;
  gap: 1.5rem;
  justify-content: center;

  a {
    color: #fff;
    text-decoration: none;
    font-size: 1.1rem;
    font-weight: 500;
    transition: color 0.3s ease;
  }

  a:hover {
    color: #eb58f9;
  }
`;

const FooterText = styled.p`
  margin-top: 1rem;
  font-size: 0.85rem;
  opacity: 0.8;
`;

function Footer() {
  return (
    <FooterContainer>
      <SocialLinks>
        <a
          href="https://github.com/ankushk385"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>
        <a
          href="https://www.linkedin.com/in/ankush-ankush-155949319/"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
      </SocialLinks>

      <FooterText>
        &copy; {new Date().getFullYear()} Ankush. All rights reserved.
      </FooterText>
    </FooterContainer>
  );
}

export default Footer;
